import axios from "axios";
import React, { useContext, useEffect } from "react";
import { Navigate } from "react-router-dom";
import FormContext from "../context/FormContext";

export const ProtectedRoute = ({ children }) => {
  const context = useContext(FormContext);
  const { setBranch } = context;

  const GetData = async () => {
    await axios
      .post("https://erpapi.eshiksa.net/formBilderBranchDetails.php", {
        Branch_id: localStorage.getItem("Branch_id"),
        dbname: "erp_eshiksa",
        tag: "formbuilderBranchdetail",
      })
      .then((res) => {
        if (res.data.error !== 1) {
          setBranch(res.data.data[0]);
        } else {
          return null;
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    GetData(); // eslint-disable-next-line
  }, []);

  if (localStorage.getItem("Branch_id")) {
    return children;
  } else {
    return <Navigate to="/" />;
  }
};
